import { atom } from "recoil";
import { ISubscription } from "../../app/models/ISubscriptionDetails";
import { recoilPersist } from "recoil-persist";


const {persistAtom} = recoilPersist({
    key:'subscription-state',
    storage: localStorage
});
   

export const subscriptionState = atom({
	key: "subscriptionState",
	default: {} as ISubscription,
    effects_UNSTABLE: [persistAtom],
});
